type Product = "fair" | "studio" | "hub";

export function productUrls(pageUrl: string, overrides: Partial<Record<Product, string>> = {}): Record<Product, string> {
  const page = new URL(pageUrl);
  const local = ["localhost", "127.0.0.1", "[::1]"].includes(page.hostname);
  const sibling = (port: number) => {
    const url = new URL("/", page);
    url.port = String(port);
    return url.href;
  };

  return {
    fair: overrides.fair?.trim() || (local ? sibling(5177) : new URL("/rainfair/", page).href),
    studio: overrides.studio?.trim() || sibling(local ? 5173 : 8083),
    hub: overrides.hub?.trim() || sibling(local ? 5175 : 8081),
  };
}
